import React, {useState} from 'react';


const Lista_video_da_studiare = (props) => {

    console.log('lista_video_da_studiare.js')
    console.log(props.lista_file_video)
    const vettore1 = [...props.lista_file_video]
      

    
    const onChangeValue = (event) => {
      console.log('lista_video_da_studiare.js - onchangevalue')
      console.log(props.utente)
      console.log(props.todos)
      console.log(props.video_scelto)
      console.log(event)
      var url_scelto = event.target.value    
      
      const sweeterArray = props.lista_file_video.map((itemtodo, index) => {
      if (vettore1[index].file === url_scelto) 
              props.funzione_scelta_video({indice: index, url: url_scelto} ) 
      })
    }

    

    return (
    <div>
        <div onChange={onChangeValue}>
         
            {vettore1.map((item,index) => (
                <p> <input  key={index} type="radio" value={vettore1[index].file} name="gender" defaultChecked={index === 0} /> {vettore1[index].n_r} </p>
            ))}
             
        </div>

    </div>
    )

  }

export default Lista_video_da_studiare;